module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "office-modal"
  }, [_c('div', {
    staticClass: "office-modal__overlay"
  }, [_c('div', {
    staticClass: "office-modal__container"
  }, [_c('div', {
    staticClass: "office-modal__close",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "office-modal__content"
  }, [_c('swiper', {
    ref: "myOfficeSwiper",
    staticClass: "office-modal__slider-container",
    attrs: {
      "options": _vm.swiperOption
    }
  }, _vm._l((_vm.props), function(image, i) {
    return _c('swiper-slide', {
      key: i,
      staticClass: "office-modal__slide"
    }, [_c('img', {
      staticClass: "about-us__image",
      attrs: {
        "src": image.url
      }
    })])
  })), _c('div', {
    staticClass: "office-modal__next",
    on: {
      "click": function($event) {
        _vm.slideNext()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-circle"
    }
  })], 1), _c('div', {
    staticClass: "office-modal__prev",
    on: {
      "click": function($event) {
        _vm.slidePrev()
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": "arrow-circle"
    }
  })], 1)], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d956810","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/office-modal/office-modal.pug
// module id = 533
// module chunks = 1